export default function getFullUrl(input: any) {
    if(input[0] === 'h' && input[1] === 't') return input;
    return 'https://' + input;
}